/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TenantLicensePlanDto } from './TenantLicensePlanDto';
import {
    instanceOfTenantLicensePlanDto,
    TenantLicensePlanDtoFromJSON,
    TenantLicensePlanDtoFromJSONTyped,
    TenantLicensePlanDtoToJSON,
} from './TenantLicensePlanDto';

/**
 * @type TenantLicenseDataDtoLicensePlan
 * 
 * @export
 */
export type TenantLicenseDataDtoLicensePlan = TenantLicensePlanDto;


export function TenantLicenseDataDtoLicensePlanFromJSON(json: any): TenantLicenseDataDtoLicensePlan {
    return TenantLicenseDataDtoLicensePlanFromJSONTyped(json, false);
}

export function TenantLicenseDataDtoLicensePlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantLicenseDataDtoLicensePlan {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...TenantLicensePlanDtoFromJSONTyped(json, true) };
    return  TenantLicensePlanDtoFromJSONTyped(json, true);
}

export function TenantLicenseDataDtoLicensePlanToJSON(value?: TenantLicenseDataDtoLicensePlan | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfTenantLicensePlanDto(value)) {
        return TenantLicensePlanDtoToJSON(value as TenantLicensePlanDto);
    }

    return {};
}

/**
 * Check if a given object implements the TenantLicenseDataDtoLicensePlan interface.
 */
export function instanceOfTenantLicenseDataDtoLicensePlan(value: any): value is TenantLicenseDataDtoLicensePlan {
    if (instanceOfTenantLicensePlanDto(value)) return true;
    return false;
}

